<template>
  <div>
    <Main />
  </div>
</template>

<script>
import Main from "../../canads/terrenos/maplocation/Main.vue";

export default {
  name: "Menu",
  components: {
    Main,
  },
};
</script>
